<script lang="ts">
  import * as Store from '@/store';
  import {isMobile} from '@/store';
  import {project} from '@/store';
  import Swal from 'sweetalert2';
  import type {Video} from '@/types/project';
  import {MENU, STEP} from '@/types/common';
  import {tooltip} from '@/actions/tippy-action';
  import {beta} from '@/lib/beta/beta';
  import {onMount} from 'svelte';

  export let carousel: string;
  export let index: number;

  $: {
    const parser = new DOMParser();
    const doc = parser.parseFromString(carousel, 'text/html');
    carousel = doc.body.textContent || '';
  }

  const handleScroll = () => {
    const sliders = document.querySelectorAll<HTMLElement>('.scrollbar-hide');

    sliders.forEach(slider => {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      slider.addEventListener('mousedown', (e: MouseEvent) => {
        isDown = true;
        slider.classList.add('cursor-grabbing');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('cursor-grabbing');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('cursor-grabbing');
      });

      slider.addEventListener('mousemove', (e: MouseEvent) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  };

  onMount(() => {
    handleScroll();
  });
  // export let verse: string;

  // export let selectedVideo: Video | null;
</script>

<section class="flex w-full flex-col">
  <div class="flex min-h-[240px] w-[240px] items-center justify-center rounded-xl bg-zinc-100 p-4">
    <p class="text-center text-base leading-6 text-zinc-700">
      {@html carousel}
    </p>
  </div>
  <div class="py-2 text-sm text-dark-400 font-secondary">
    {index === 0 ? 'Title' : `Slide ${index}`}
  </div>
</section>
